import { render, staticRenderFns } from "./WhatsappConfirmation.vue?vue&type=template&id=22ad6b1b&"
import script from "./WhatsappConfirmation.vue?vue&type=script&lang=js&"
export * from "./WhatsappConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports